import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsCW: CultureInfo = {
  name: 'es-CW',
  displayName: 'español (Curazao)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-CW',
  parent: CultureInfoEs
};
